import { render, staticRenderFns } from "./column4.vue?vue&type=template&id=a9f51a78&scoped=true&"
import script from "./column4.vue?vue&type=script&lang=js&"
export * from "./column4.vue?vue&type=script&lang=js&"
import style0 from "./column4.vue?vue&type=style&index=0&id=a9f51a78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f51a78",
  null
  
)

export default component.exports